import { createApp } from 'vue';
import { createVuestic } from "vuestic-ui";

import "animate.css";
import "vuestic-ui/dist/vuestic-ui.css";

import App from './App.vue';
import router from "@/router";
import eventBus from "@/utils/eventBus";
import constants from "@/utils/constant";
import store from "@/store";

const app = createApp(App);

app.use(router);
app.use(createVuestic());
app.use(store);

app.config.globalProperties.$bus = eventBus;
app.config.globalProperties.$constants = constants;

app.mount('#app');
